import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=f647f52a&scoped=true&"
import script from "./RoundedButton.vue?vue&type=script&lang=js&"
export * from "./RoundedButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&id=f647f52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f647f52a",
  null
  
)

export default component.exports